import { render, staticRenderFns } from "./apartment-price-table.vue?vue&type=template&id=71122f40&scoped=true&"
import script from "./apartment-price-table.ts?vue&type=script&lang=ts&"
export * from "./apartment-price-table.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-price-table.scss?vue&type=style&index=0&id=71122f40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71122f40",
  null
  
)

export default component.exports